<template>
  <svg width="34"
       height="34"
       viewBox="0 0 34 34"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_3254_5037)">
      <circle cx="17" cy="18" r="13" fill="url(#paint0_linear_3254_5037)" />
    </g>
    <path
      d="M10.3333 13.6667L11.1426 14.6667L13.9999 12M10.3333 18.3333L11.1426 19.3333L13.9999 16.6667M10.3333 23L11.1426 24L13.9999 21.3333"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M23.6667 18H20.3333M17 18H18M17 22.6667H20.3333M22.6667 22.6667H23.6667M23.6667 13.3333H17"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round" />
    <defs>
      <filter id="filter0_d_3254_5037"
              x="0"
              y="0"
              width="34"
              height="34"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="-1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0 0 0 0 0 0.9 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3254_5037" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3254_5037" result="shape" />
      </filter>
      <linearGradient id="paint0_linear_3254_5037"
                      x1="26"
                      y1="5"
                      x2="8"
                      y2="31"
                      gradientUnits="userSpaceOnUse">
        <stop stop-color="#DB00FF" />
        <stop offset="1" stop-color="#880083" />
      </linearGradient>
    </defs>
  </svg>
</template>
